module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldIt.b57d4d5.ttf";